import useTabParam from '../../hooks/useTabParam';
import UploadBulkAction from "./UploadBulkAction";
import BulkActionDetails from "./BulkActionDetails";
import PageTitle from "../../components/PageTitle";
import PillFilters from '../AppointmentDeliveriesV2/shared/PillFilters';

const PILLS = [
    { key: '1', label: 'Upload Bulk Action' },
    { key: '2', label: 'Uploaded File Details' },
];

function WeightDiscrepancyBulkAction() {
    const [view, setView] = useTabParam('1');
    return (
        <>
            <PageTitle>Weight Discrepancy Bulk Action</PageTitle>
            <PillFilters pills={PILLS} value={view} onChange={setView} />
            {view === '1' && <UploadBulkAction />}
            {view === '2' && <BulkActionDetails />}
        </>
    );
}

export default WeightDiscrepancyBulkAction;
